import React from 'react';

import { HistoryLocation, NavigationHistoryPathType } from '../../../types';

import { Location } from '../Location/Location';
import { LocationIcon } from './LocationIcon/LocationIcon';

import { useStyles } from './styles';
import { useGetHistoryEventTitle } from 'entities/navigation/hooks';

export const Path = ({ startLocation, endLocation, type }: PathProps) => {
  const classes = useStyles({ type });
  const getHistoryEventTitle = useGetHistoryEventTitle();
  return (
    <div className={classes.container}>
      <Location
        startLocation={startLocation}
        endLocation={endLocation}
        title={getHistoryEventTitle(type)}
        icon={<LocationIcon type={type} />}
      />
    </div>
  );
};

export interface PathProps {
  startLocation: HistoryLocation;
  endLocation: HistoryLocation;
  type: NavigationHistoryPathType;
}
